export default __webpack_public_path__ + "static/media/brainflix-desktop-revised.610e4914.jpg";